import { IssueCaseDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeIssueCaseDoc } from 'src/utils/firebase/firebase-short-cut';

const useIssueCaseById = (issueId: string | undefined) => {
  const [isLoading, setIsLoading] = useState(true);
  const [issue, setIssue] = useState<IssueCaseDoc | undefined>();

  useEffect(() => {
    if (issueId) {
      setIsLoading(true);
      const subscription = observeIssueCaseDoc(issueId).subscribe((doc) => {
        setIssue(doc);
        setIsLoading(false);
      });

      return () => {
        subscription.unsubscribe();
        setIssue(undefined);
        setIsLoading(false);
      };
    } else {
      setIssue(undefined);
      setIsLoading(false);
    }
  }, [issueId]);

  return { issue, isLoading };
};

export default useIssueCaseById;
